	export const getTextColorLL = (value: string) => {
		const status = {
			"4": "text-yellow-600",
			"6": "text-red-600",
			"12": "text-green-600",
		}

		return status[value]
	}